export const classes = {
  section: 'py-5',
};
